import * as React from "react";
const SvgMessageQuestionCircle = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.17773 7.91853C8.32456 7.50113 8.61438 7.14917 8.99585 6.92498C9.37731 6.70079 9.82581 6.61884 10.2619 6.69364C10.698 6.76844 11.0936 6.99517 11.3785 7.33367C11.6635 7.67217 11.8194 8.1006 11.8188 8.54306C11.8188 9.79213 9.94517 10.4167 9.94517 10.4167M9.9681 12.9167H9.97643M17.5039 10C17.5039 14.1421 14.146 17.5 10.0039 17.5C8.3069 17.5 2.50451 17.5 2.50451 17.5C2.50451 17.5 3.80384 14.3801 3.28383 13.334C2.78462 12.3297 2.50391 11.1976 2.50391 10C2.50391 5.85786 5.86177 2.5 10.0039 2.5C14.146 2.5 17.5039 5.85786 17.5039 10Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgMessageQuestionCircle;
